module.exports = __webpack_public_path__ + "static/media/bonheur.217b7c7d.png";